export default "__VITE_ASSET__CAW02rYn__"